class MProductSection extends HTMLElement {
  constructor() {
    super();
    this.onProductAjaxAdded = this.onProductAjaxAdded.bind(this);
  }

  connectedCallback() {
    // Expect the section element to have data-section-id="{{ section.id }}"
    this.sectionId = this.dataset.sectionId || null;
    if (!this.sectionId) return;

    this.sectionEl = document.getElementById('shopify-section-' + this.sectionId);
    if (!this.sectionEl) return;

    // Elements
    this.sizeButtons = Array.from(this.sectionEl.querySelectorAll('.size-button'));
    this.variantInputAddToCart = document.getElementById('AddToCartVariant-' + this.sectionId);
    this.variantInputBuyNow = document.getElementById('BuyNowVariant-' + this.sectionId);
    this.selectedSizeLabel = document.getElementById('SelectedSize-' + this.sectionId);

    // Initialize UI and listeners
    this._initSizeButtons();

    // Listen for Minimog product add events (the unified add-to-cart handler dispatches this)
    document.addEventListener('product-ajax:added', this.onProductAjaxAdded);
  }

  disconnectedCallback() {
    document.removeEventListener('product-ajax:added', this.onProductAjaxAdded);
    this.sizeButtons.forEach(btn => btn.removeEventListener('click', this._onSizeClick));
  }

  _initSizeButtons() {
    if (!this.sizeButtons.length) return;

    // Keep a bound handler reference so we can remove it later if needed
    this._onSizeClick = (evt) => {
      const btn = evt.currentTarget;
      this._activateSizeButton(btn);
    };

    this.sizeButtons.forEach(btn => {
      // store defaults (in case styles are toggled)
      btn.dataset.defaultColor = btn.dataset.defaultColor ?? getComputedStyle(btn).color;
      btn.dataset.defaultBg = btn.dataset.defaultBg ?? getComputedStyle(btn).backgroundColor;

      btn.addEventListener('click', this._onSizeClick);
    });
  }

  _activateSizeButton(btn) {
    // Deactivate others
    this.sizeButtons.forEach(b => {
      b.classList.remove('active');
      if (b.dataset.defaultColor) b.style.color = b.dataset.defaultColor;
      if (b.dataset.defaultBg)  b.style.background = b.dataset.defaultBg;
    });

    // Activate chosen
    btn.classList.add('active');

    // Update visible selected label if present
    if (this.selectedSizeLabel) {
      this.selectedSizeLabel.textContent = btn.dataset.variantTitle || btn.textContent.trim();
    }

    // Update variant inputs for forms (Minimog add-to-cart listens to form inputs)
    const variantId = btn.dataset.variantId;
    if (variantId) {
      if (this.variantInputAddToCart) this.variantInputAddToCart.value = variantId;
      if (this.variantInputBuyNow) this.variantInputBuyNow.value = variantId;
    }

    // Apply active styles if provided
    if (btn.dataset.activeColor) btn.style.color = btn.dataset.activeColor;
    if (btn.dataset.activeBg) btn.style.background = btn.dataset.activeBg;
  }

  /**
   * When the unified Minimog Add-to-Cart finishes it dispatches:
   *   document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product } }));
   *
   * We listen for that and then:
   *  - ask Minimog to refresh the cart-count section
   *  - dispatch cart:refresh with open: true so MCartDrawer will fetch updated HTML and open
   */
  onProductAjaxAdded(event) {
    // 1) Refresh cart-count section (so header bubble updates). This follows your Minimog pattern.
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections: ['cart-count'] }
      })
    );

    // 2) Trigger cart refresh + open for the drawer
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: { open: true }
      })
    );

    // 3) Also re-emit Minimog pubSub cartUpdate if product payload included a cart snapshot
    //    (not strictly necessary because Minimog's add-to-cart handler should have done this,
    //     but harmless if present)
    if (window.MinimogEvents && window.MinimogTheme && event?.detail?.product) {
      try {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: event.detail.product });
      } catch (err) {
        // fail silently if pubSub shape differs
      }
    }
  }
}

customElements.define('m-product-section', MProductSection);
